module.exports = __webpack_public_path__ + "static/media/redeemcash.bf58d0fb.png";